export { Iconify26 } from "./Iconify26";
